import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  CardTitle,
} from "reactstrap";
import CustomModal from "../../../../../../Components/Modals/CustomModal";
import { connect } from "react-redux";
import SelectableProductWidget from "../../../../../Components/Widgets/Products/SelectableProductWidget";
import SelectableProductWidgetList from "../../../../../Components/Widgets/Products/SelectableProductWidgetList";
import SelectableParentProductWidget from "../../../../../Components/Widgets/Products/SelectableParentProductWidget";
import { FormatProductWidgetData } from "../../../../../Components/Widgets/Products/WidgetDataFunctions/FormatProductWidgetData";
import WidgetListCard from "../../../../../../Components/Widgets/WidgetListCard";
import StarRating from "../../../Components/Rating/StarRating";
import Vector_Arrow from "./../../../../../../../designUtils/Logo/Vector_Arrow.svg";
import Arrow_DownWords from "./../../../../../../../designUtils/Logo/Arrow_DownWords.svg";
import Stop_icon from "../../../../../../../designUtils/img/pause.svg";
import Play_icon from "../../../../../../../designUtils/img/play.svg";
import Alert_icon from "../../../../../../../designUtils/img/Alert.svg";
import Ticket_icon from "../../../../../../../designUtils/img/Ticket_icon.svg"
import Info from "../../../../../../../designUtils/img/info.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import GetCatalogueProductDetailsService from "../../../../../../../Service/DashboardServices/AccountOverviewServices/StoreServices/GetCatalogueProductDetailsService";
import CatalogueItemDetails from "../../../../../Components/Widgets/Products/CatalogueItemDetails";
import QuickLaunchCampaignService from "../../../../../../../Service/DashboardServices/AccountOverviewServices/ProductServices/QuickLaunchCampaignService";
import StoreOverviewService from "../../../../../../../Service/DashboardServices/AccountOverviewServices/StoreServices/StoreOverviewService";
import ProductsAlertTicketCreate from "../../../../TroubleTickets/Components/ProductTickets/ProductsAlertTicketCreate";
import CampaignLaunchTutorialModal from "../Modals/CampaignLaunchTutorialModal";
import QuickLaunchCampaignModal from "../Modals/QuickLaunchCampaignModal";
import UpdateCampaignBudgetModal from "../Modals/UpdateCampaignBudgetModal";
import CampaignOverviewService from "../../../../../../../Service/DashboardServices/AccountOverviewServices/CampaignServices/CampaignOverviewService";
import Group from '../../../../../../../assets/img/StoreOverview_Img/Group.png'
import { useHistory } from "react-router-dom";
import AmazonProductListingMainPage from "../../../../ProductListingApi_v1/AmazonProductListingMainPage";
import urls from '../../../../../../../Utils/URLs';
import FetchAmazonListingService from "../../../../../../../Service/OPSServices/AmazonProductListing_v1/FetchAmazonListingService";
import AmazonListingInfo from "./AssetGallery_v2/Components/Components/Product/AmazonListingInfo";
import fetchProductListingDataService from "../../../../../../../Service/OPSServices/AmazonProductListing_v1/fetchProductListingDataService";
import AmazonProductListingEditableField from "../../../../ProductListingApi_v1/Components/AmazonProductListingEditableField";
import patchListingFieldsService from "../../../../../../../Service/OPSServices/AmazonProductListing_v1/patchListingFieldsService";
import AmazonProductListingUpdatePopup from "../../../../ProductListingApi_v1/Components/AmazonProductListingUpdatePopup";
import notify from '../../../../../../../Notifications/ToastifyActions';
import BackButton from "../../../../../../../designUtils/Logo/BackButton.svg";
import updateAllListingSkusService from "../../../../../../../Service/OPSServices/AmazonProductListing_v1/updateAllListingSkusService";

function ProductDetailsAboveThousand(props) {
  const [budgetIsOpen, setBudgetIsOpen] = useState(false);


  const [isOpen, setIsOpen] = useState(false);
  const [isOpenChaild, setIsOpenChaild] = useState(false);
  const [isOpenOPChaild, setIsOpenOPChaild] = useState(false);
  const [parentToggleId, setParentToggleId] = useState();
  const [childToggleId, setChildToggleId] = useState();

  //   right side card
  const [isTicketListOpen, setIsTicketListOpen] = useState(false);
  const [asinForTicketList, setAsinForTicketList] = useState();
  const [catlogProductDetails, setCatlogProductDetails] = useState();
  const [isOpenCatalogueItem, setIsOpenCatalogueItem] = useState();
  const [isManagementOpen, setIsManagementOpen] = useState(false);

  const [loadingUpdate, setLoadingUpdate] = useState("paused");
  const [isCampaignTutorialOpen, setIsCampaignTutorialOpen] = useState(false);
  const [hideCampaignTutorial, setHideCampaignTutorial] = useState(
    JSON.parse(localStorage.getItem("hide-campaign-tutorial")) || false
  );
  const [isCampaignOpen, setIsCampaignOpen] = useState(false);
  // const [asinArray, setAsinArray] = useState([]);
  // const [checked, setChecked] = useState(false);

  //Amazon Listing 
  const [showSkuModal, setShowSkuModal] = useState(false);
  const [selectedAsin, setSelectedAsin] = useState("");
  const [selectedSku, setSelectedSku] = useState("");
  const [tempSelectedSku, setTempSelectedSku] = useState("");
  const history = useHistory();
  const [selectedOfferSku, setSelectedOfferSku] = useState("");
  const [offerLoading, setOfferLoading] = useState(false);
  const [purchasableOfferField, setPurchasableOfferField] = useState(null);
  const [editedOfferValue, setEditedOfferValue] = useState(null);
  const [isOfferModalOpen, setIsOfferModalOpen] = useState(false);
  const [savingOffer, setSavingOffer] = useState(false);
  const [offerSaveModalData, setOfferSaveModalData] = useState(null);
  const [isOfferSaveModalOpen, setIsOfferSaveModalOpen] = useState(false);
  const [isOfferSkuConfirmOpen, setIsOfferSkuConfirmOpen] = useState(false);
  useEffect(()=>{
      setIsOpenChaild(false)
  },[props.storeOverview.integerID])

  useEffect(() => {
    if (props.selectedProduct) {
      setChildProductData({
        productTitle: props.selectedProduct.productTitle,
        asin: props.selectedProduct.asin,
        price: props.selectedProduct.itemPrice,   // <-- IMPORTANT (itemPrice)
        brand: props.selectedProduct.brand,
        productBudget: props.selectedProduct.productBudget,
        link: props.selectedProduct.link,
        sku: props.selectedProduct.sku,
        skus: props.selectedProduct.skus,
        IntegerId: props.selectedProduct.IntegerId,
        simpliworksManagementState: props.selectedProduct.simpliworksManagementState,
        salesRanking: props.selectedProduct.salesRanking
      });
    }
  }, [props.selectedProduct]);
  
  
  const [childProductData, setChildProductData] = useState({
    productTitle:'',
    asin: "",
    price: "",
    brand: "",
    productBudget: "",
    link: "",
    sku: "",
    skus: [],
    IntegerId: "",
    simpliworksManagementState: "",
    salesRanking: ''
  });
  const [newCampaignDetails, setNewCampaignDetails] = useState({
    productASIN: "",
    productSKU: "",
    skuList: [],
    dailyBudget: 50,
  });
  const managementStates = {
    INACTIVE: "unManaged",
    ACTIVE: "managed",
    PAUSED: "paused",
  };
  // console.log(props.storeOverview.integerID);
  // console.log(props.storeIntegerID);
  const toggleState = () => {
    if (
      childProductData.simpliworksManagementState === "paused" ||
      childProductData.simpliworksManagementState === "unManaged"
    ) {
      setChildProductData({
        ...childProductData,
        simpliworksManagementState: "managed",
      });
      props.updateProductManagement(childProductData.asin, "resume");
    } else {
      setChildProductData({
        ...childProductData,
        simpliworksManagementState: "paused",
      });
      props.updateProductManagement(childProductData.asin, "pause");
    }
  };
  const renderTicketList = (asin) => {
    setAsinForTicketList(asin);
    setIsTicketListOpen(true);
  };


  const handleProductDetails = async (asin,sku, integerId) => {
    let data={
      integerId:props.storeOverview.integerID,
      asin:asin,
      sku:sku,
      sellerPartnerId:props.storeOverview.stringID,
      // integerId:integerId

    }
    let response =await FetchAmazonListingService(props.token,data)
    console.log(response)
    // let response = await GetCatalogueProductDetailsService(
    //   props.token,
    //   asin,
    //   integerId
    // );

    // if (response) {
      console.log("response");
      setCatlogProductDetails(<AmazonListingInfo data={response} childProductData={childProductData} />);
      setIsOpenCatalogueItem(true);
    // }
  };
  function handleClickViewAnalytic() {
    alert("Development for this functionality is in progress.");
  }
  const toggleCampaignModal = (asin, skuList) => {
    console.log(asin)
    console.log(skuList)
    if (!hideCampaignTutorial) {
      setIsCampaignTutorialOpen(!isCampaignTutorialOpen);
    }
    setIsCampaignOpen(!isCampaignOpen);
    setNewCampaignDetails((prevState) => ({
      productSKU: skuList ? skuList[0] : "",
      productASIN: asin,
      skuList: skuList,
      dailyBudget: prevState.dailyBudget,
    }));
  };

  useEffect(() => {
    localStorage.setItem(
      "hide-campaign-tutorial",
      JSON.stringify(hideCampaignTutorial)
    );
  }, [hideCampaignTutorial]);

  const handleQuickLaunchCampaign = async (asin, sku, dailyBudget) => {
    setIsManagementOpen(true);
    let response = await QuickLaunchCampaignService(
      props.token,
      props.storeIntegerID,
      asin,
      sku,
      dailyBudget
    );
    if (response) {
      props.dispatch(StoreOverviewService(
        props.token,
        props.storeIntegerID,
        props.storeAccountID
      )
      );
    }
    return response;
  };
  const handleCreateAndViewTicketClose = (response) => {
    setIsTicketListOpen(false);
  };
 
  let groupedWidgets = props.parentProducts.map((parent) => {
    const { productTitle, asin, itemImage, isParentProduct } = parent;

    if (!isParentProduct) return FormatProductWidgetData(parent); // orphan product, not parent

    const details = {
      productVariation: asin,
    };

    let childVariations = props.childProducts.filter(
      (child) => child.parentProduct === parent.asin
    );

    return {
      productName: productTitle,
      productImage: itemImage,
      details: details,
      children: childVariations,
      isParentProduct: isParentProduct,
      numManagedChildren: childVariations.reduce(
        (count, childProduct) => count + childProduct.isManaged,
        0
      ),
    };
  });

  groupedWidgets = groupedWidgets.filter(
    (parent) => !parent.isParentProduct || parent.children.length !== 0
  );
 
  const updateBudget = () => {
    // console.log("first surya")
    // loadCampaignInfo(name, campaignID);
    setBudgetIsOpen(!budgetIsOpen);
    return <UpdateCampaignBudgetModal isOpen={true} toggle={() => setBudgetIsOpen(!budgetIsOpen)} />
  }

  const handleOptimizeListing = (asin, skus) => {
  
      setSelectedAsin(asin);
    
      const skuList = skus
        ? skus.filter((sku) => sku && sku.trim() !== "")
        : [];
    
      // Zero SKU
      if (skuList.length === 0) {
        setTempSelectedSku("");
      setShowSkuModal(true);
      }
    
      // Single SKU → direct redirect
      if (skuList.length === 1) {
    
        history.push({
          pathname: "/amazon-product-listing",
          state: {
            asin: asin,
            sku: skuList[0],
            storeDetails: props.storeOverview,
            backRoute: urls.BASE_AMAZON_LISTING_URL
          }
        });
    
        return;
      }
    
      // Multiple SKU → open modal
      setTempSelectedSku(skuList[0]);
      setShowSkuModal(true);
    };
    const fetchOfferForSku = async (sku) => {
      setSelectedOfferSku(sku);
      setPurchasableOfferField(null);
      setEditedOfferValue(null);
      if (!sku) return;
      setOfferLoading(true);
      try {
        const requestData = {integerId:props.storeIntegerID, asin: childProductData.asin, sku: sku };
        const res = await fetchProductListingDataService(props.token, requestData);
        if (res && res.status === "READY" && res.fields) {
          const offerField = res.fields.find((f) => f.field === "purchasable_offer");
          setPurchasableOfferField(offerField || null);
        }
      } catch (err) {
        console.error(err);
      }
      setOfferLoading(false);
    };
  
    const handleOpenOffers = () => {
      setSelectedOfferSku("");
      setPurchasableOfferField(null);
      setEditedOfferValue(null);
      setIsOfferModalOpen(true);
    };
    const handleValidateOffer = async (updatedValue) => {
      setSavingOffer(true);
      const requestData = {
        integerId:props.storeIntegerID,
        asin: childProductData.asin,
        sku: selectedOfferSku,
        mode: "VALIDATION_PREVIEW",
        updates: [{ field: "purchasable_offer", value: updatedValue }]
      };
      const res = await patchListingFieldsService(props.token, requestData);
      if (res) {
        setOfferSaveModalData(res);
        setIsOfferSaveModalOpen(true);
      }
      setSavingOffer(false);
    };
  
    const handleUpdateOfferLive = async () => {
      setSavingOffer(true);
      const requestData = {
        integerId:props.storeIntegerID,
        asin: childProductData.asin,
        sku: selectedOfferSku,
        mode: "LIVE",
        updates: [{ field: "purchasable_offer", value: editedOfferValue }]
      };
      const res = await patchListingFieldsService(props.token, requestData);
      if (res) {
        setOfferSaveModalData(res);
        if (!res.issues || res.issues.length === 0) {
          if (res.status === "ACCEPTED") {
            notify.NotifySuccess("Update submitted successfully. Amazon is processing it — changes may take a few minutes to reflect on the live listing.");
          } else {
            notify.NotifyWarning("Update submitted, but Amazon hasn't confirmed acceptance yet. Please check the listing history for status.");
          }
          setIsOfferModalOpen(false);
          setPurchasableOfferField(null);
        } else {
          notify.NotifyError("Update failed. Please review the issues and try again.");
        }
      } else {
        notify.NotifyError("Update failed. Please try again.");
      }
      setSavingOffer(false);
    };
    const handleUpdateAllOfferSkus = async () => {
      if (savingOffer) return;
    
      const allSkus =
        childProductData &&
        childProductData.skus
          ? childProductData.skus.filter(
              sku => sku && String(sku).trim() !== ""
            )
          : [];
    
      if (
        !childProductData ||
        !childProductData.asin ||
        !selectedOfferSku ||
        allSkus.length === 0
      ) {
        notify.NotifyError("Required listing information is missing.");
        return;
      }
    
      setIsOfferSkuConfirmOpen(false);
      setSavingOffer(true);
    
      try {
        const requestData = {
          asin: childProductData.asin,
          sku: selectedOfferSku,
          skus: allSkus,
          integerId: props.storeIntegerID,
          updates: [
            {
              field: "purchasable_offer",
              value: editedOfferValue
            }
          ]
        };
    
        const res = await updateAllListingSkusService(
          props.token,
          requestData
        );
    
        console.log("All SKU Offer Feed Response:", res);
    
        if (res && res.status) {
          setOfferSaveModalData({
            ...res,
            mode: "LIVE",
            updateType: "ALL_SKUS",
            updatedFields: requestData.updates,
            updatedSkus: allSkus
          });
    
          // Keep the updated value visible for the currently selected SKU
          setPurchasableOfferField(prevField => {
            if (!prevField) return prevField;
    
            return {
              ...prevField,
              normalized_value: editedOfferValue,
              listing: {
                ...prevField.listing,
                value: editedOfferValue
              }
            };
          });
    
          notify.NotifySuccess(
            "Listing update submitted successfully to Amazon. Changes may take some time to reflect."
          );
    
          setIsOfferModalOpen(false);
        } else {
          notify.NotifyError(
            res && res.message
              ? res.message
              : "Failed to submit listing update."
          );
        }
      } catch (error) {
        console.error("Update all offer SKUs failed:", error);
    
        notify.NotifyError(
          "Failed to submit listing update for all SKUs."
        );
      } finally {
        setSavingOffer(false);
      }
    };
    const isOfferListingValid =
    offerSaveModalData &&
    offerSaveModalData.type !== "WARNING" &&
    offerSaveModalData.mode === "VALIDATION_PREVIEW" &&
    (!offerSaveModalData.issues || offerSaveModalData.issues.length === 0);
  return (
    <>
      {/* <WidgetListCard
        widgets={groupedWidgets}
        renderWidgetListItem={renderGroupedProductWidgets}
        card={props.card}
        setClass={props.setClass}
      /> */}
      <Row className='d-flex'>
        <Col
          md={12}
          className="p-0 rightside-card"
          style={{ position: "sticky", top: "4rem", right: '0' }}
        >
          <Card className={childProductData ? "m-3" : "m-3"}>
            <CardBody className="p-0 detail-card">
              <div className="p-4">
                <div className="d-flex justify-content-around mb-3">
                  {props.UserPermission?props.UserPermission.Products_ManageUnmanage && <button className="btn-product" onClick={toggleState}>

                    {childProductData.simpliworksManagementState === "unManaged" ?
                      <img
                        src={Play_icon}
                        alt="Start"
                        title="Start Managment"
                        width={30}
                        height={30}
                      /> : childProductData.simpliworksManagementState === "paused" ? (
                        <img
                          src={Play_icon}
                          alt="Stop"
                          title="Start Managment"
                          width={30}
                          height={30}
                        />
                      ) : (
                        <img
                          src={Stop_icon}
                          alt="Play"
                          title="Pause Management"
                          width={30}
                          height={30}
                        />
                      )}
                    <br></br>
                    Manage
                  </button>:''}

                  {props.UserPermission?props.UserPermission.Products_ProductsCreateTicketPopUp && <button

                    className="btn-product"
                    onClick={() => renderTicketList(childProductData.asin)}
                  >
                    <img src={Ticket_icon} width={30} height={30} title="Create ticket" />
                    <br></br>
                    Tickets
                  </button>:''}
                  <button
                    onClick={() =>
                      handleProductDetails(
                        childProductData.asin,
                        childProductData.skus,
                        childProductData.IntegerId
                      )
                    }
                    className="btn-product"
                  >
                    <img src={Info} width={30} height={30} title="Details" />
                    <br></br>
                    &nbsp; &nbsp; Info  &nbsp; &nbsp;
                  </button>
                </div>
                <Col md={12}>
        <Row className="align-items-start">
            <Col md={8}>
            <div className="padding-2">
                  <p>
                    <b>ASIN:</b> {childProductData.asin}
                  </p>
                  <p>
                    <b>Brand:</b> {childProductData.brand ? childProductData.brand : 'Unavailable'}
                  </p>
                  <p>
                    <b>Budget:</b>  {childProductData.productBudget != 'None' ? "$" + childProductData.productBudget + '/day' : '$0.00/day'} <a onClick={() => updateBudget()} href='#'>&#40;<u>Edit</u>&#41;</a>
                  </p>
                  <p>
                  <b>Price:</b> {childProductData.price? (String(childProductData.price).includes('$')? childProductData.price: `$${childProductData.price}`): '$0.00'}

                  </p>
                  <p className="mb-0">
                    <b>Best Sellers Rank :</b>
                  </p>
                  {childProductData.salesRanking ?
                    childProductData.salesRanking.split(',').map((part, index) => (
                      <React.Fragment key={index}>
                        {part.trim()}<br />
                      </React.Fragment>
                    ))
                    : ''}
                </div> </Col>
                  {/* IMAGE LEFT */}
            <Col md={4} className="text-center">
                <div>
                {props.selectedProduct && props.selectedProduct.itemImage && (
            <img
            src={props.selectedProduct.itemImage}
            alt="Product"
            style={{ maxWidth: "100%", maxHeight: "250px", objectFit: "contain" }}
            />
        )}
                </div></Col>

                </Row>
                </Col>
               
                <p color="light" className="text-center">
                  <span
                    className={` ${childProductData.simpliworksManagementState === managementStates.ACTIVE
                        ? "text-brand-blue-dark"
                        : childProductData.simpliworksManagementState === managementStates.PAUSED
                          ? "text-warning"
                          : ""
                      }`}
                  >
                    <i
                      className={` ${childProductData.simpliworksManagementState ===
                          managementStates.ACTIVE
                          ? "pe-7s-check mt-2"
                          : childProductData.simpliworksManagementState ===
                            managementStates.PAUSED
                            ? "pe-7s-attention text-warning"
                            : "pe-7s-close mt-2 text-danger"
                        }`}
                      style={{
                        fontSize: "14",
                        color: "green",
                        fontWeight: "bold",
                      }}
                    ></i>
                    {childProductData.simpliworksManagementState ===
                      managementStates.ACTIVE
                      ? " Managed by Simpliworks"
                      : childProductData.simpliworksManagementState ===
                        managementStates.PAUSED
                        ? " Paused"
                        : "Unmanaged"}
                  </span>
                </p>
                <p className="text-center">
                  <a href={childProductData.link} target="_blank">
                    Visit on Amazon
                  </a>
                </p>
              </div>
              <div className="d-flex justify-content-around pb-3">
                <button
                  className="green-btn pl-3 pr-3"
                  onClick={handleClickViewAnalytic}
                >
                  View Analytics
                </button>
                <button
                  className="green-btn pl-3 pr-3"
                  onClick={handleOpenOffers}
                >
                  Purchasable Offer
                </button>
                <button
                  className="green-btn pl-3 pr-3"
                  onClick={() =>
                    handleOptimizeListing(
                      childProductData.asin,
                      childProductData.skus
                    )
                  }
                >
                  Optimize Listing
                </button>
              </div>
              {props.UserPermission? props.UserPermission.Products_OneClickCampaign && <div className="text-center campaign-div">
                  <button
                    class="campaign-btn"
                    role="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleCampaignModal(
                        childProductData.asin,
                        childProductData.skus
                      );
                    }}
                  >
                    1-Click Campaign
                  </button>
                </div>:''}

                {/* ) : (
                    ""
                  )} */}
              </CardBody>
              </Card>
        </Col></Row>
     
      <CustomModal
        header={<><h5><b>Create Ticket For :</b>  <img
          width={props.storeOverview.logo  ? '180' : 50}
          height={50}
          src={props.storeOverview.logo? props.storeOverview.logo : Group} /> {props.storeOverview.name}</h5></>}
        isOpen={isTicketListOpen}
        toggle={() => setIsTicketListOpen(!isTicketListOpen)}
        size={"xl"}
        className="bgColor"
      >
        <ProductsAlertTicketCreate
          asinForTicketList={asinForTicketList}
          handleCreateAndViewTicketClose={handleCreateAndViewTicketClose}
          childProductData={childProductData}
        />
      </CustomModal>
      <CustomModal
        header={"1-Click Campaign"}
        isOpen={isCampaignOpen}
        toggle={() => setIsCampaignOpen(!isCampaignOpen)}
        size={"sm"}
        className="bgColor"
      >
        <QuickLaunchCampaignModal
          isCampaignOpen={isCampaignOpen}
          setIsCampaignOpen={setIsCampaignOpen}
          newCampaignDetails={newCampaignDetails}
          setNewCampaignDetails={setNewCampaignDetails}
          isManagementOpen={isManagementOpen}
          setIsManagementOpen={setIsManagementOpen}
          handleQuickLaunchCampaign={handleQuickLaunchCampaign}
          integerId={props.storeIntegerID}
          token={props.token}
        />
      </CustomModal>
      <CustomModal
        header={"1"}
        isOpen={isCampaignTutorialOpen}
        toggle={() => setIsCampaignTutorialOpen(!isCampaignTutorialOpen)}
        size={"sm"}
        className=""
      >
        <CampaignLaunchTutorialModal
          isOpen={isCampaignTutorialOpen}
          setIsOpen={setIsCampaignTutorialOpen}
          hideTutorial={hideCampaignTutorial}
          setHideTutorial={setHideCampaignTutorial}
        />
      </CustomModal>
      <CustomModal
        header={"Product Details"}
        isOpen={isOpenCatalogueItem}
        className=""
        toggle={() => setIsOpenCatalogueItem(!isOpenCatalogueItem)}
        size={"lg"}
        footer={
          <>
            <Button
              color={"link"}
              onClick={() => setIsOpenCatalogueItem(!isOpenCatalogueItem)}
            >
              Cancel
            </Button>
          </>
        }
      >
         {catlogProductDetails}
      </CustomModal>
      <CustomModal
    header={"Select SKU"}
    isOpen={showSkuModal}
    toggle={() => setShowSkuModal(!showSkuModal)}
    className='curve-popup'
    footer={(
        <>
         <Button
                onClick={() => {
                    setShowSkuModal(false);
                    setSelectedSku("");
                }}
            >
                Cancel
            </Button>
            <Button
                className="btn btn-success"
                disabled={!tempSelectedSku}
                onClick={() => {

                  setShowSkuModal(false);

                  history.push({
                    pathname: "/amazon-product-listing",
                    state: {
                        asin: selectedAsin,
                        sku: tempSelectedSku,
                        storeDetails: props.storeOverview,
                        backRoute: urls.BASE_AMAZON_LISTING_URL
                    }
                });
                }}
            >
                Submit
            </Button>

           
        </>
    )}
>

    <div className="mt-2">

        {childProductData &&
        childProductData.skus &&
        childProductData.skus.length > 0 ? (

            <>
                <Label>Select SKU</Label>

                <Input
                    type="select"
                    value={tempSelectedSku}
                    onChange={(e) =>
                        setTempSelectedSku(e.target.value)
                    }
                >

                    {childProductData.skus.map((sku, index) => (
                        <option
                            key={index}
                            value={sku}
                        >
                            {sku}
                        </option>
                    ))}

                </Input>
            </>
        ) : (
            <div className="text-center text-danger mt-3">
                SKU not available for this ASIN.
            </div>
        )}

    </div>

</CustomModal>
<CustomModal
        header="Validate Listing"
        isOpen={isOfferSaveModalOpen}
        toggle={() => setIsOfferSaveModalOpen(!isOfferSaveModalOpen)}
        size="lg"
        className="curve-popup"
      >
        <div className="p-3" style={{ minHeight: "150px" }}>
          {offerSaveModalData && (
            <AmazonProductListingUpdatePopup
              data={offerSaveModalData}
              onUpdate={() => {
                setIsOfferSaveModalOpen(false);
              
                const allSkus =
                  childProductData &&
                  childProductData.skus
                    ? childProductData.skus.filter(
                        sku => sku && String(sku).trim() !== ""
                      )
                    : [];
              
                if (allSkus.length > 1) {
                  setIsOfferSkuConfirmOpen(true);
                } else {
                  handleUpdateOfferLive();
                }
              }}
              isListingValid={isOfferListingValid}
              saving={savingOffer}
              mode={offerSaveModalData.mode}
            />
          )}
        </div>
      </CustomModal>
      <CustomModal
          header="Purchasable Offer"
          isOpen={isOfferModalOpen}
          toggle={() => setIsOfferModalOpen(false)}
          size="lg"
          className=" offer-modal purchasable-offer-modal"
        >
          <div className="offer-container">
            {/* Header */}
            <div className="offer-header border-bottom pb-3">
              <Row className="align-items-center ">
                <Col xs="auto">
                  <Label className="font-weight-bold mb-0">
                    SKU :
                  </Label>
                </Col>
                <Col xs="auto">
                  <Input
                    type="select"
                    value={selectedOfferSku}
                    disabled={offerLoading}
                    onChange={(e) => fetchOfferForSku(e.target.value)}
                    style={{ width: "260px" }}
                  >
                    <option value="">--Select a SKU--</option>

                    {childProductData && childProductData.skus && childProductData.skus.map((sku, index) => (
                      <option key={index} value={sku}>
                        {sku}
                      </option>
                    ))}
                  </Input>
                </Col>
              </Row>
            </div>
            {/* Column Header */}
            <div className="offer-column">
              <div className="offer-grid-header">
                <div className="offer-grid-cell border-right">
                  Listing
                </div>
                <div className="offer-grid-cell">
                  Edit
                </div>
              </div>
            </div>
            {/* Body */}
            <div className="offer-body">
              {offerLoading ? (
                <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100%" }}
                >
                Loading offer details...
                </div>
              ) : !selectedOfferSku ? (
                <div
                  className="d-flex justify-content-center align-items-center text-muted"
                  style={{ height: "100%" }}
              >
                  <h6 className="mb-0">
                      Select a SKU to view its offer details
                  </h6>
              </div>
              ) : purchasableOfferField ? (
              <div className="offer-edit-wrapper">
                <AmazonProductListingEditableField
                  field={purchasableOfferField}
                  embedded
                  hideCatalog
                  onFieldChange={(update) =>
                    setEditedOfferValue(update.value)
                  }
                /></div>
              ) : (
                <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100%" }}
            >
                No purchasable offer data found.
            </div>
              )}
            </div>
            {/* Footer */}
            <div className="offer-footer border-top pt-3 d-flex justify-content-end">
              <Button
                // color="light"
                className="no-btn-background-color mr-4"
                onClick={() => setIsOfferModalOpen(false)}
              >
                Cancel
              </Button>
              <Button
                // color="success"
                className="btn-background-color"
                disabled={
                  !selectedOfferSku ||
                  !editedOfferValue ||
                  savingOffer
                }
                onClick={() => handleValidateOffer(editedOfferValue)}
              >
                {savingOffer ? "Validating..." : "Validate"}
              </Button>
            </div>
          </div>
        </CustomModal>
        <CustomModal
          header="Confirm Listing Update"
          isOpen={isOfferSkuConfirmOpen}
          toggle={() => setIsOfferSkuConfirmOpen(false)}
          size="lg"
          className="curve-popup"
        >
          <div className="p-4">
            <p className="mb-3">
              This ASIN is associated with multiple SKUs. Would you like to apply
              these changes to the current SKU only or to all associated SKUs?
            </p>
            <div className="mb-3">
              <div>
                <b>ASIN:</b> {childProductData.asin}
              </div>
              <div className="mt-2">
                <b>Current SKU:</b> {selectedOfferSku}
              </div>
            </div>
            <div className="mb-4">
              <b>Associated SKUs:</b>
              <div
                className="mt-2"
                style={{
                  maxHeight: "180px",
                  overflowY: "auto"
                }}
              >
                {childProductData &&
                  childProductData.skus &&
                  childProductData.skus.map(sku => (
                    <div key={sku} className="mb-1">
                      • {sku}
                      {sku === selectedOfferSku && (
                        <span className="text-muted ml-2">
                          (Current)
                        </span>
                      )}
                    </div>
                  ))}
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <Button
                className="no-btn-background-color mr-3"
                disabled={savingOffer}
                onClick={() => {
                  setIsOfferSkuConfirmOpen(false);
                  handleUpdateOfferLive();
                }}
              >
                Update Current SKU
              </Button>
              <Button
                className="btn-background-color"
                disabled={savingOffer}
                onClick={handleUpdateAllOfferSkus}
              >
                {savingOffer ? "Updating..." : "Update All SKUs"}
              </Button>
            </div>
          </div>
        </CustomModal>
          </>
        );
      }
// export default ProductListUpto5000;
const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    storeOverview: state.accountOverview.store.storeOverview,
    // childProducts: state.accountOverview.store.childProducts,
    adProfiles: state.accountOverview.landing.adProfiles,
    // Power BI Reports
    UserPermission: state.accountOverview.store.StoreUserPermission,
    weeklyReport: state.accountOverview.store.weeklyReport,
    ProductPerformanceReport: state.accountOverview.store.ProductPerformanceReport,
    TargetPerformanceReport: state.accountOverview.store.TargetPerformanceReport,
    StoreOverviewReport: state.accountOverview.store.StoreOverviewReport,
    WeeklySalesReport: state.accountOverview.store.WeeklySalesReport,
    SalesTrendsReport: state.accountOverview.store.SalesTrendsReport,
    WeeklySearchTermReport: state.accountOverview.store.WeeklySearchTermReport,
    CampaignPerformanceReport: state.accountOverview.store.CampaignPerformanceReport,

    storeLoading: state.accountOverview.store.loading,
    status: state.accountOverview.store.status,
    campaignData: state.accountOverview.product.campaignData,
    productCampaigns: state.accountOverview.product.productCampaigns,

  };
};
export default connect(mapStateToProps)(ProductDetailsAboveThousand);